<template>
  <div :class="$style.wrapper">
    <section :class="$style.topSection">
      <!-- <button
        type="button"
        :class="$style.exportBtn"
        :disabled="isExporting || !items.length"
        @click="handleExportCatalog"
      >
        <span :class="$style.exportIcon" aria-hidden="true">
          <img src="@/assets/img/account/my-products/export.svg" alt="export" />
        </span>
        {{ isExporting ? "Экспортируется..." : "Экспортировать каталог" }}
      </button> -->

      <!-- <div :class="$style.notice">Внимание! Комиссия бирже составляет 15%</div> -->

      <div :class="$style.progressCard">
        <div :class="$style.progressHeader">
          <span :class="$style.progressLabel"
            >Мин. кол-во позиций для торговли</span
          >
          <span :class="$style.progressValue">
            <span :class="$style.progressCurrent">{{
              profileProductsCount
            }}</span>
            <span :class="$style.progressDivider"> / </span>
            <span :class="$style.progressMax">{{ maxProducts }}</span>
          </span>
        </div>
        <div :class="$style.progressBar">
          <span :style="{ width: progressPercent + '%' }"></span>
        </div>
      </div>
    </section>

    <section :class="$style.listSection">
      <template v-if="isLoading">
        <div
          v-for="n in skeletonCount"
          :key="`my-products-skeleton-${n}`"
          :class="$style.cardSkeleton"
        >
          <div :class="['skeleton', $style.skeletonThumb]"></div>
          <div :class="['skeleton', $style.skeletonLine]"></div>
          <div :class="['skeleton', $style.skeletonLineShort]"></div>
        </div>
      </template>

      <template v-else-if="!items.length">
        <div :class="$style.emptyState">
          <p>Тут пока пусто</p>
          <span>
            Добавьте свой первый товар, чтобы он появился в каталоге.
          </span>
        </div>
      </template>

      <template v-else>
        <article
          v-for="product in items"
          :key="product.id"
          :class="$style.card"
        >
          <div :class="$style.previewRow">
            <DragScroll :className="$style.previewScroll" :interactive="true">
              <div
                v-for="(image, index) in previewImages(product)"
                :key="`${product.id}-${index}`"
                :class="$style.previewItem"
              >
                <img
                  :src="image"
                  :alt="product.model?.title"
                  loading="lazy"
                  draggable="false"
                />
              </div>
              <div
                v-if="!previewImages(product).length"
                :class="[$style.previewItem, $style.previewStub]"
              >
                <span>Нет фото</span>
              </div>
            </DragScroll>
          </div>

          <div :class="$style.tags">
            <span
              :class="[
                $style.tag,
                product.moderation_status === 'approved'
                  ? $style.tagSuccess
                  : product.moderation_status === 'rejected'
                  ? $style.tagDanger
                  : $style.tagWarn,
              ]"
            >
              {{ moderationLabel(product.moderation_status) }}
            </span>
            <span
              v-if="
                product.is_custom &&
                (!product.custom_images || product.custom_images.length === 0)
              "
              :class="[$style.tag, $style.tagDanger]"
            >
              Добавьте фото кастома
            </span>
            <span
              v-if="product.is_trade"
              :class="[$style.tag, $style.tagNeutral]"
            >
              Торг
            </span>
            <span v-if="product.count" :class="[$style.tag, $style.tagNeutral]">
              {{ pluralizePairs(product.count) }}
            </span>
            <span v-if="product.size" :class="[$style.tag, $style.tagNeutral]">
              {{ product.size }} {{ product.size_type }}
            </span>
          </div>

          <h2 :class="$style.title">{{ product.model?.title }}</h2>

          <div :class="$style.priceRow">
            <div :class="$style.priceBlock">
              <div :class="$style.priceLine">
                <div :class="$style.price">
                  {{ formatPrice(product.price) }} ₽
                </div>
                <div
                  v-if="discountPercent(product) !== null"
                  :class="$style.discountChip"
                >
                  <span :class="$style.discountIcon"></span>
                  <span>{{ discountPercent(product) }}%</span>
                </div>
              </div>
            </div>
            <div :class="$style.actionButtons">
              <button
                type="button"
                :class="$style.editBtn"
                @click.stop="editProduct(product.id)"
              >
                <img
                  src="@/assets/img/account/my-products/edit.svg"
                  alt="Редактировать"
                />
              </button>
            </div>
          </div>
        </article>
      </template>
    </section>

    <div
      v-if="showAddModal"
      :class="[$style.modalOverlay, addModalClosing && $style.fadeOut]"
      @click.self="closeAddModal()"
    >
      <div :class="[$style.modal, addModalClosing && $style.slideDown]">
        <button
          type="button"
          :class="$style.modalClose"
          @click="closeAddModal()"
        >
          &times;
        </button>
        <div :class="$style.modalPlus">
          <img src="@/assets/img/account/my-products/plus.svg" alt="plus" />
        </div>
        <h2 :class="$style.modalTitle">Выберите способ загрузки</h2>
        <p :class="$style.modalSubtitle">
          Он напрямую влияет на механику добавления позиций товаров
        </p>

        <div :class="$style.modalOptionsGroup">
          <label :class="$style.optionRow">
            <input
              type="radio"
              name="upload"
              value="manual"
              v-model="uploadMethod"
            />
            <div :class="$style.optionContent">
              <div :class="$style.optionTitle">Добавление вручную</div>
            </div>
          </label>

          <div :class="$style.optionDivider"></div>

          <label :class="$style.optionRow">
            <input
              type="radio"
              name="upload"
              value="excel"
              v-model="uploadMethod"
            />
            <div :class="$style.optionContent">
              <div :class="$style.optionTitle">Excel-шаблон</div>
            </div>
          </label>
        </div>

        <button
          v-if="!hasTelegramMainButton"
          type="button"
          :class="[$style.primaryBtn, $style.modalConfirm]"
          @click="handleUploadConfirm"
        >
          Продолжить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DragScroll from "@/components/DragScroll.vue"
import { pluralizePairs } from "@/utils/pluralize"

export default {
  name: "MyProducts",
  components: {
    DragScroll,
  },
  data() {
    return {
      isLoading: true,
      isLoadingMore: false,
      hasMore: true,
      limit: 100,
      offset: 0,
      sort: "date_desc",
      maxProducts: 10,
      skeletonCount: 4,
      showAddModal: false,
      uploadMethod: "manual",
      mbHandler: null,
      addModalClosing: false,
      modalCloseTimer: null,
      hasTelegramMainButton: false,
      mainButtonMode: "add",
      mainButtonInstance: null,
      isExporting: false,
    }
  },
  computed: {
    items() {
      return this.$store.state.myProducts?.items || []
    },
    profileProductsCount() {
      return this.$store.state.myProductsCount ?? 0
    },
    progressPercent() {
      if (!this.maxProducts) {
        return 0
      }
      return Math.min(
        100,
        Math.round((this.profileProductsCount / this.maxProducts) * 100)
      )
    },
  },
  async mounted() {
    await Promise.all([
      this.fetchProducts(true),
      this.$store.dispatch("getProfile"),
    ])
    this.setupMainButton()
    window.addEventListener("scroll", this.handleScroll)
  },
  beforeUnmount() {
    this.destroyMainButton()
    if (this.modalCloseTimer) {
      clearTimeout(this.modalCloseTimer)
    }
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    pluralizePairs,
    async fetchProducts(reset = false) {
      if (reset) {
        this.offset = 0
        this.hasMore = true
        this.isLoading = true
      } else {
        if (!this.hasMore || this.isLoadingMore) return
        this.isLoadingMore = true
      }

      try {
        const response = await this.$store.dispatch("getMyProducts", {
          limit: this.limit,
          offset: this.offset,
          sort: this.sort,
        })

        const newItems = response?.items || []

        // Проверяем, есть ли еще данные
        this.hasMore = newItems.length === this.limit
        if (this.hasMore) {
          this.offset += this.limit
        }
      } catch (error) {
        window.console.error("Не удалось загрузить товары", error)
      } finally {
        this.isLoading = false
        this.isLoadingMore = false
      }
    },
    handleScroll() {
      if (this.isLoading || this.isLoadingMore || !this.hasMore) return

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight

      // Загружаем, когда осталось 200px до конца
      if (scrollTop + windowHeight >= documentHeight - 200) {
        this.fetchProducts(false)
      }
    },
    previewImages(product) {
      const modelImages = product?.model?.images || []
      const customImages = product?.custom_images || []

      // Извлекаем URL из кастомных изображений
      const customImageUrls = customImages
        .map((item) => item?.url)
        .filter((url) => url) // Фильтруем пустые значения

      // Кастомные изображения в начале, затем основные изображения модели
      const allImages = [...customImageUrls, ...modelImages]

      return allImages
    },
    moderationLabel(status) {
      if (status === "approved") {
        return "Опубликовано"
      }
      if (status === "rejected") {
        return "Отклонено"
      }
      return "На модерации"
    },
    formatPrice(value) {
      const number = Number(value)
      return Number.isNaN(number) ? value : number.toLocaleString("ru-RU")
    },
    discountPercent(product) {
      const candidates = [
        product?.market_discount,
        product?.market_diff,
        product?.discount,
        product?.discount_percent,
        product?.model?.market_discount,
        product?.model?.market_diff,
      ]
      const raw = candidates.find(
        (v) => v !== undefined && v !== null && v !== ""
      )
      if (raw === undefined) return null
      const num = Number(raw)
      if (Number.isNaN(num)) return null
      return Math.abs(Math.round(num))
    },
    isOnModeration(product) {
      const status = product?.moderation_status
      return status !== "approved" && status !== "rejected"
    },
    openProduct(id) {
      this.$router.push({
        name: "Product",
        params: { id },
      })
    },
    editProduct(id) {
      // Находим продукт в списке для получения moderation_status
      const product = this.items.find((p) => p.id === id)
      const moderationStatus = product?.moderation_status || null

      this.$router.push({
        name: "EditProduct",
        params: { id },
        query: moderationStatus ? { moderation_status: moderationStatus } : {},
      })
    },
    setupMainButton() {
      this.setMainButtonMode("add")
    },
    destroyMainButton() {
      const mb = this.mainButtonInstance || window.Telegram?.WebApp?.MainButton
      if (mb && this.mbHandler) {
        mb.offClick(this.mbHandler)
      }
      if (mb) {
        mb.hide()
      }
      this.mbHandler = null
      this.mainButtonInstance = null
      this.hasTelegramMainButton = false
      this.mainButtonMode = "add"
    },
    setMainButtonMode(mode) {
      const tg = window.Telegram?.WebApp
      const mb = this.mainButtonInstance || tg?.MainButton
      if (!mb) {
        this.hasTelegramMainButton = false
        return
      }
      this.hasTelegramMainButton = true
      if (this.mainButtonMode === mode && this.mbHandler) {
        return
      }
      if (this.mbHandler) {
        mb.offClick(this.mbHandler)
        this.mbHandler = null
      }
      const isConfirm = mode === "confirm"
      const handler = isConfirm
        ? this.handleUploadConfirm
        : this.handleMainButtonClick
      const text = isConfirm ? "Продолжить" : "Добавить товар"
      this.mbHandler = handler
      mb.setText(text)
      mb.textColor = "#ffffff"
      mb.color = "#ff6600"
      if (mb.enable) {
        mb.enable()
      }
      if (mb.hideProgress) {
        mb.hideProgress()
      }
      mb.onClick(this.mbHandler)
      mb.show()
      this.mainButtonMode = mode
      this.mainButtonInstance = mb
    },
    handleMainButtonClick() {
      this.openAddModal()
    },
    openAddModal() {
      this.uploadMethod = "manual"
      this.addModalClosing = false
      if (this.modalCloseTimer) {
        clearTimeout(this.modalCloseTimer)
        this.modalCloseTimer = null
      }
      this.showAddModal = true
      this.setMainButtonMode("confirm")
    },
    closeAddModal(afterClose) {
      const callback = typeof afterClose === "function" ? afterClose : null
      this.setMainButtonMode("add")
      if (!this.showAddModal) {
        if (callback) callback()
        return
      }
      if (this.addModalClosing) {
        return
      }
      this.addModalClosing = true
      this.modalCloseTimer = window.setTimeout(() => {
        this.showAddModal = false
        this.addModalClosing = false
        this.modalCloseTimer = null
        if (callback) {
          callback()
        }
      }, 250)
    },
    handleUploadConfirm() {
      if (this.uploadMethod === "manual") {
        this.closeAddModal(() => {
          this.$router.push({ name: "AddedProduct" })
        })
        return
      }
      this.closeAddModal(() => {
        this.$router.push({ name: "UploadExcel" })
      })
    },
    async handleExportCatalog() {
      if (this.isExporting || !this.items.length) {
        return
      }

      this.isExporting = true
      try {
        // Собираем все ID продуктов
        const productIds = this.items.map((product) => product.id)

        // Отправляем запрос на экспорт и получаем URL файла
        const result = await this.$store.dispatch("exportProductsTable", {
          product_ids: productIds,
        })

        // Проверяем, что URL получен
        if (!result || !result.url) {
          throw new Error("Не удалось получить ссылку на файл")
        }

        const fileUrl = result.url
        window.console.log("URL файла получен:", fileUrl)

        // Используем Telegram WebApp API для открытия ссылки
        const tg = window.Telegram?.WebApp
        if (tg?.openLink) {
          // В Telegram WebApp используем openLink
          tg.openLink(fileUrl, { try_instant_view: false })
          window.console.log("Открыто через Telegram WebApp API")
        } else {
          // В обычном браузере открываем в новой вкладке
          window.open(fileUrl, "_blank")
          window.console.log("Открыто в новой вкладке")
        }

        window.console.log("Каталог успешно экспортирован")
      } catch (error) {
        window.console.error("Ошибка при экспорте каталога", error)
        const tg = window.Telegram?.WebApp
        if (tg?.showPopup) {
          tg.showPopup({
            title: "Ошибка",
            message: "Не удалось экспортировать каталог. Попробуйте еще раз.",
            buttons: [{ type: "close", text: "Ок" }],
          })
        } else {
          alert("Не удалось экспортировать каталог. Попробуйте еще раз.")
        }
      } finally {
        this.isExporting = false
      }
    },
  },
}
</script>

<style lang="scss" module>
.wrapper {
  padding: 1rem;
  min-height: 100vh;
}

.topSection {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  margin-bottom: 1.25rem;
}

.exportBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  width: 100%;
  padding: 0.75rem;
  background: #068244;
  color: #fff;
  border: none;
  border-radius: 0.625rem;
  font-weight: 500;
  font-size: 1rem;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.exportBtn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.exportIcon {
  display: inline-flex;
  width: 1.5rem;
  height: 1.5rem;
}

.exportIcon svg {
  width: 100%;
  height: 100%;
}

.notice {
  background: #f5f7fa;
  border-radius: 0.625rem;
  padding: 0.625rem;
  font-size: 0.875rem;
  color: #545458a6;
  text-align: center;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progressCard {
  background: #f5f7fa;
  border-radius: 0.625rem;
  padding: 0.625rem;
}

.progressHeader {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 0.625rem;
  align-items: center;
}

.progressBar {
  width: 100%;
  height: 2px;
  border-radius: 999px;
  background: transparent;
  overflow: hidden;
  position: relative;
}

.progressValue {
  span {
    font-size: 0.875rem;
  }
}

/* Добавим фон линии отдельно, чтобы он мог быть прозрачным или едва заметным */
.progressBar::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #b8b8bc80;
  opacity: 0.5;
  z-index: 0;
}

.progressBar span {
  display: block;
  height: 100%;
  background: #ec6608;
  border-radius: inherit;
  transition: width 0.2s ease;
  position: relative;
  z-index: 1;
}

.listSection {
  display: grid;
  gap: 0.75rem;
}

.card {
  border: none;
  min-width: 0;
}

.previewRow {
  margin-bottom: 1rem;
}

.previewScroll {
  display: flex;
  gap: 0.625rem;
  margin-left: -1rem;
  margin-right: -1rem;
  padding-left: 1rem;
  padding-right: 1rem;
}

.previewItem {
  width: 10.875rem;
  height: 10.875rem;
  flex: 0 0 auto;
  border-radius: 0.5rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}

.previewItem img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.previewStub {
  color: #9b9ba1;
  font-size: 0.85rem;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 0.625rem;
}

.tag {
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
}

.tagWarn {
  background: #ec66081a;
  color: #ec6608;
}

.tagSuccess {
  background: #e4f8eb;
  color: #1c8a4a;
}

.tagDanger {
  background: #fdeaea;
  color: #cc3a3a;
}

.tagNeutral {
  background: #ededf1;
  color: #6f6f78;
  font-weight: 500;
}

.title {
  font-size: 1rem;
  font-weight: 500;
  color: #1d1d1b;
  margin-bottom: 0.625rem;
  line-height: 1.3;
}

.progressLabel {
  color: #1d1d1b;
}

.progressValue {
  font-size: 1rem;
}

.progressCurrent {
  color: #ff7a00;
  font-weight: 600;
}

.progressDivider,
.progressMax {
  color: #1d1d1b;
}

.priceRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.actionButtons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.editBtn {
  border: none;
  background: transparent;
  padding: 0.25rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  flex-shrink: 0;

  img {
    width: auto;
    height: auto;
    object-fit: contain;
  }
}

.priceBlock {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.priceLine {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.price {
  font-size: 1.5rem;
  font-weight: 600;
  color: #111;
}

.discountChip {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.1rem 0.4rem;
  border-radius: 0.4rem;
  background: #e5f7eb;
  color: #16a34a;
  font-size: 0.75rem;
  font-weight: 700;
}

.discountIcon {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  background: #22c55e;
  position: relative;
}

.discountIcon::before {
  content: "";
  position: absolute;
  left: 0.2rem;
  top: 0.15rem;
  width: 0.3rem;
  height: 0.4rem;
  border: 1.5px solid #fff;
  border-top: none;
  border-right: none;
  transform: rotate(-45deg);
}

.cardSkeleton {
  border: 1px solid #ebeaea;
  border-radius: 1rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.skeletonThumb {
  width: 100%;
  height: 6rem;
  border-radius: 0.5rem;
}

.skeletonLine {
  width: 70%;
  height: 1rem;
  border-radius: 0.5rem;
}

.skeletonLineShort {
  width: 40%;
  height: 0.85rem;
  border-radius: 0.5rem;
}

.emptyState {
  text-align: center;
  background: #fff;
  border-radius: 1rem;
  padding: 2rem 1.5rem;
  border: 1px dashed #d4d4db;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  color: #6f6f78;
}

.emptyState p {
  font-size: 1.1rem;
  font-weight: 600;
  color: #111;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(16px);
  }
}

@keyframes modalFadeOut {
  from {
    opacity: 1;
    backdrop-filter: blur(16px);
  }
  to {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
}

@keyframes modalSlideUp {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes modalSlideDown {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(40px);
    opacity: 0;
  }
}

.modalOverlay {
  position: fixed;
  inset: 0;
  background: rgba(8, 9, 12, 0.5);
  backdrop-filter: blur(16px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1000;
  animation: modalFadeIn 0.25s ease;
}

.fadeOut {
  animation: modalFadeOut 0.25s ease forwards;
}

.modal {
  background: #fff;
  border-radius: 0.75rem 0.75rem 0 0;
  width: 100%;
  padding: 1.25rem 1rem;
  position: relative;
  text-align: center;
  box-shadow: 0 -18px 40px rgba(15, 23, 42, 0.25);
  animation: modalSlideUp 0.25s ease;
}

.slideDown {
  animation: modalSlideDown 0.25s ease forwards;
}

.modalClose {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: #0000001a;
  border: none;
  width: 1.875rem;
  height: 1.875rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: #8e8e93;
}

.modalPlus {
  width: 3.625rem;
  height: 3.625rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem auto 2rem auto;
}

.modalTitle {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.625rem;
  color: #000;
}

.modalSubtitle {
  color: #545458a6;
  font-size: 1rem;
  margin-bottom: 1.25rem;
  line-height: 1.4;
  max-width: 21.25rem;
  margin: 0 auto 1.25rem auto;
}

.modalOptionsGroup {
  border: 1px solid #e5e5ea;
  border-radius: 1rem;
  overflow: hidden;
  margin-bottom: 1rem;
  background: #fff;
}

.optionRow {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 1rem;
  cursor: pointer;
  text-align: left;
}

.optionContent {
  flex: 1;
}

.optionDivider {
  height: 1px;
  background: #e5e5ea;
  margin-left: 3.35rem; /* Отступ слева, чтобы линия начиналась под текстом */
}

.optionRow input[type="radio"] {
  appearance: none;
  width: 1.5rem;
  height: 1.5rem;
  border: 2px solid #d1d1d6;
  border-radius: 50%;
  margin-top: 0.1rem;
  flex-shrink: 0;
  display: grid;
  place-content: center;
  transition: all 0.2s ease;
}

.optionRow input[type="radio"]:checked {
  background-color: #e65c00;
  border-color: #e65c00;
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='10' viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5L4.5 8.5L11 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
}

.optionTitle {
  font-weight: 500;
  font-size: 1rem;
  color: #000;
}

.optionDesc {
  font-size: 0.875rem;
  color: #8e8e93;
}

.modalConfirm {
  margin-top: 0;
}

@media (min-width: 768px) {
  .wrapper {
    padding: 2rem 2.5rem 6rem;
  }

  .listSection {
    grid-template-columns: repeat(2, 1fr);
  }
}

.loadingMore {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

.loadingSpinner {
  width: 2rem;
  height: 2rem;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-top-color: #000;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
